import { PresaleContent } from '@/components/showtimes/presale-content';
import { Anchor } from '@/components/ui/anchor';
import { MoviePoster } from '@/types/movie-poster';
import { buildMovieUrlWithDate } from '@/utils/url-params';

type PresaleNoShowtimeContentComponentProps = {
  dataLinkCategory?: string;
  dataLinkName?: string;
  moviePoster: MoviePoster;
  presaleLinkText?: string;
  presaleLinkUrl?: string;
  presaleMessage: string;
  publicOnSaleDate?: Date;
};

export const PresaleNoShowtimeContentComponent = ({
  dataLinkCategory,
  dataLinkName,
  moviePoster,
  presaleLinkText,
  presaleLinkUrl,
  presaleMessage,
  publicOnSaleDate,
}: PresaleNoShowtimeContentComponentProps): React.JSX.Element => {
  const dateLabel = publicOnSaleDate
    ? publicOnSaleDate.toLocaleDateString('en-US', { day: 'numeric', month: 'long' })
    : undefined;
  const viewButtonLabel = dateLabel ? `View ${dateLabel} Showtimes` : 'View Details';
  const anchorHref = publicOnSaleDate
    ? buildMovieUrlWithDate(moviePoster.movieUrl, publicOnSaleDate)
    : moviePoster.movieUrl;

  return (
    <PresaleContent analyticsLinkName={`Movie Details Dialog Presale Link - ${moviePoster.movieTitle}`}
      contentClassName="flex flex-col gap-3 lg:flex-row lg:items-center md:justify-between"
      headingDataTest="presale-dialog-header"
      iconClassName="icon w-24 flex-none"
      linkDataTest="dialog-link-movie-details"
      messageDataTest="presale-dialog-message"
      presaleLinkText={presaleLinkText}
      presaleLinkUrl={presaleLinkUrl}
      presaleMessage={presaleMessage}
    >
      <Anchor data-test="link-presale-movie-details"
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        href={anchorHref}
      >
        {viewButtonLabel}
      </Anchor>
    </PresaleContent>
  );
};
